import React from 'react';
import PropTypes from 'prop-types';
import { PerformanceMarkerProvider } from '@bingads-webui-campaign-react/performance-marker-provider';
import { StepWizard } from '@bingads-webui-campaign-react/step-wizard';
import { PERF_MAX_CAMPAIGN_CRUD_SCENARIOS } from '../common/perf-max-campaign-crud-scenarios';

export const PerfMaxAssetGroupSettingsPage = (props) => {
  const routeToNavigateToWhenDone = '/campaign/vnext/assetgroups';
  const scopeToRemoveWhenDone = ['assetGroupId'];

  return (
    <PerformanceMarkerProvider
      name={PERF_MAX_CAMPAIGN_CRUD_SCENARIOS.PERF_MAX_ASSET_GROUP_SETTINGS.scenarioName}
      instrumentation={props.instrumentation}
      immediateDone
    >
      <StepWizard
        wizardScenario={PERF_MAX_CAMPAIGN_CRUD_SCENARIOS.PERF_MAX_ASSET_GROUP_SETTINGS}
        routeToNavigateToWhenDone={routeToNavigateToWhenDone}
        scopeToRemoveWhenDone={scopeToRemoveWhenDone}
        {...props}
      />
    </PerformanceMarkerProvider>
  );
};

PerfMaxAssetGroupSettingsPage.propTypes = {
  instrumentation: PropTypes.shape({}).isRequired,
};
